// extracted by mini-css-extract-plugin
module.exports = {"expandButton":"style__expandButton__ZeBG0","nav":"style__nav__r1eTX","collapsed":"style__collapsed__1PiGy"};